import { gql, useMutation } from '@apollo/client';
import type {
  createAppointment,
  createAppointmentVariables,
} from './__generated__/createAppointment';

export const CREATE_APPOINTMENT = gql`
  mutation createAppointment(
    $counsellorId: String!
    $date: Date!
    $time: String!
    $serviceId: ID!
    $emailAddress: String!
    $phoneNumber: String!
    $filters: BookingFilters!
  ) {
    createAppointment(
      input: {
        counsellorId: $counsellorId
        date: $date
        time: $time
        serviceId: $serviceId
        emailAddress: $emailAddress
        phoneNumber: $phoneNumber
        filters: $filters
      }
    ) {
      id
      service {
        id
        name
      }
      dateFrom
      status
      timeZone
    }
  }
`;

export const useCreateAppointment = (onCompleted?: () => void) =>
  useMutation<createAppointment, createAppointmentVariables>(
    CREATE_APPOINTMENT,
    {
      errorPolicy: 'all',
      onCompleted,
      context: { timeout: 20000 }, // @TODO: hard-coded value for now - but something we could create as a configurable variable later
    },
  );
